// extracted by mini-css-extract-plugin
export default {"dropdown":"jr3BRkSkl7GKrDTeWT7l"};